var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    [
      _c("label", [_vm._v(_vm._s(_vm.fieldLabel))]),
      _vm._v(" "),
      _c(
        "Multiselect",
        _vm._g(
          _vm._b(
            { staticClass: "edit-multiselect" },
            "Multiselect",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }